import "core-js/modules/es.object.assign.js";
import { h } from "vue";
//@ts-ignore
import { getDefaultSvgPropsValues } from "@vueEntry/SvgIcons/DefaultValues";
export var DrawIcon = function DrawIcon(props, _ref) {
  var attrs = _ref.attrs;
  var _a, _b, _c, _d;
  props = Object.assign(Object.assign({}, getDefaultSvgPropsValues()), props);
  var _props = props,
    width = _props.width,
    height = _props.height,
    strokeColor = _props.strokeColor,
    fillColor = _props.fillColor;
  return h("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.522 17.639",
    width: "".concat(width),
    height: "".concat(height),
    "class": (_a = props["class"]) !== null && _a !== void 0 ? _a : "",
    "aria-hidden": (_b = attrs["aria-hidden"]) !== null && _b !== void 0 ? _b : "true"
  }, h("g", {
    fill: "none",
    stroke: "".concat((_c = attrs["stroke-color"]) !== null && _c !== void 0 ? _c : "#2b5dff"),
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "".concat((_d = attrs["stroke-width"]) !== null && _d !== void 0 ? _d : "1.5"),
    d: "m18.121 2.121-8 8-8-8"
  }, [h("path", {
    d: "M1.551 16.883a.375.375 0 0 1-.414-.329v-.005l-.38-3.666a1.142 1.142 \n            0 0 1 .247-.833l8.509-10.6a1.524 1.524 0 0 1 2.138-.234h.006l2.584 2.078a1.523 \n            1.523 0 0 1 .24 2.141v.006l-8.509 10.6a1.153 1.153 0 0 1-.76.419Z"
  }), h("path", {
    d: "m7.782 3.61 5.013 3.925"
  }), h("path", {
    d: "M9.112 16.883h7.66"
  })]));
};